import { createBrowserRouter } from 'react-router-dom';

import { AuthenticationGuard } from '@/auth';
import { UserProvider } from '@/auth/user-context-provider';
import { HsmAdminEmbed } from '@/components/hsm-admin-embed';
import RouteErrorBoundary from '@/components/route-error-boundary';

const router = createBrowserRouter([
  {
    path: '',
    element: (
      <UserProvider>
        <AuthenticationGuard>
          <HsmAdminEmbed />
        </AuthenticationGuard>
      </UserProvider>
    ),
    errorElement: <RouteErrorBoundary />,
  },
]);

export default router;
